import { Button, Modal } from 'antd';
import { useState } from 'react';

export function WarningModal() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button variant="solid" color="danger" onClick={() => setIsOpen(true)}>
                Удалить
            </Button>
            <Modal
                open={isOpen}
                onOk={() => setIsOpen(false)}
                onCancel={() => setIsOpen(false)}
                footer={false}
            >
                <div
                    style={{
                        textAlign: 'center',
                        color: 'white',
                        fontSize: '24px',
                        marginTop: '84px',
                    }}
                >
                    Куаныш разберется :)
                </div>
            </Modal>
        </>
    );
}
